import { useState } from 'react';

export const usePagination = (items, itemsPerPage = 2) => {
  const [currentPage, setCurrentPage] = useState(0);
  const [transitionClass, setTransitionClass] = useState('fade');

  const handleNext = () => {
    setTransitionClass('fade');
    setCurrentPage(currentPage + 1);
  };

  const handlePrev = () => {
    setTransitionClass('fade-reverse');
    setCurrentPage(currentPage - 1);
  };

  const startIndex = currentPage * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const visibleItems = items.slice(startIndex, endIndex);

  return {
    currentPage,
    transitionClass,
    handleNext,
    handlePrev,
    visibleItems,
    startIndex,
    endIndex,
  };
};
